<template>
  <div id="SquareSpace" style="margin-left:10%;padding-top:5rem">
    <img
      src="@/assets/img/integration/squarespace-logo.png"
      style="max-width: 55%; margin:auto; display:block;"
    />
    <h2 class="mt-3 documentation-header">
      How to Setup a Cense AI Chatbot for SquareSpace
    </h2>
    <div style="margin-top: 3%">
      <h6>1. Login to your SquareSpace Admin area</h6>
    </div>
    <div style="margin-top: 3%">
      <h6>2. Click Settings</h6>
    </div>
    <div style="margin-top: 3%">
      <h6>3. Click on Advanced</h6>
    </div>
    <div style="margin-top: 3%">
      <h6>4. Click Code Injection</h6>
    </div>
    <div style="margin-top: 3%">
      <h6>5. Scroll down to the Footer Box</h6>
    </div>
    <div style="margin-top: 3%">
      <h6>
        6. Place the copied code from Squarespace Settings (in Miscellaneous
        Menu of Cense Portal) in the Footer Box
      </h6>
    </div>
    <div style="margin-top: 3%">
      <h6>7. Click Save Settings</h6>
    </div>
  </div>
</template>

<script>
export default {
  name: "squarespace",
};
</script>

<style scoped>
h6 {
  font: normal normal normal 1rem/2.5rem Poppins;
}
</style>
